// src/actions/videoSubmissionActions.js

// Action Types
export const REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL =
  "REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL";
export const REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_SUCCESS =
  "REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_SUCCESS";
export const REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_FAILURE =
  "REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_FAILURE";

export const UPLOAD_VIDEO_FILE = "UPLOAD_VIDEO_FILE";
export const UPLOAD_VIDEO_FILE_SUCCESS = "UPLOAD_VIDEO_FILE_SUCCESS";
export const UPLOAD_VIDEO_FILE_FAILURE = "UPLOAD_VIDEO_FILE_FAILURE";
export const UPLOAD_VIDEO_FILE_PROGRESS = "UPLOAD_VIDEO_FILE_PROGRESS";

export const RESET_VIDEO_SUBMISSION_STATE = "RESET_VIDEO_SUBMISSION_STATE";

// Action Creators
export const requestVideoSubmissionPresignedUrl = (payload) => ({
  type: REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL,
  payload,
});

export const requestVideoSubmissionPresignedUrlSuccess = (presignedUrl) => ({
  type: REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_SUCCESS,
  payload: presignedUrl,
});

export const requestVideoSubmissionPresignedUrlFailure = (error) => ({
  type: REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_FAILURE,
  payload: error,
});

export const uploadVideoFile = (file, presignedUrl, fileName) => ({
  type: UPLOAD_VIDEO_FILE,
  payload: { file, presignedUrl, fileName },
});

export const uploadVideoFileSuccess = () => ({
  type: UPLOAD_VIDEO_FILE_SUCCESS,
});

export const uploadVideoFileFailure = (error) => ({
  type: UPLOAD_VIDEO_FILE_FAILURE,
  payload: error,
});

export const uploadVideoFileProgress = (progress) => ({
  type: UPLOAD_VIDEO_FILE_PROGRESS,
  payload: progress,
});

export const resetVideoSubmissionState = () => ({
  type: RESET_VIDEO_SUBMISSION_STATE,
});
